import { render, staticRenderFns } from "./CreateClaim.vue?vue&type=template&id=614e7dca"
import script from "./CreateClaim.vue?vue&type=script&lang=js"
export * from "./CreateClaim.vue?vue&type=script&lang=js"
import style0 from "./CreateClaim.vue?vue&type=style&index=0&id=614e7dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports